import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import url from './url';

function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setError('');
        setMessage('');

        if (!email.trim()) {
            setError('Enter your email address.');
            return;
        }

        setIsSubmitting(true);
        try {
            const response = await fetch(`${url}/api/password-reset/forgot`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Email: email }),
            });
            const data = await response.json().catch(() => ({}));
            if (!response.ok) throw new Error(data.message || 'Unable to send a reset link.');
            setMessage(data.message);
        } catch (submitError) {
            setError(submitError.message || 'Unable to send a reset link.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <main className="auth-page">
            <section className="auth-card">
                <span className="section-kicker">ACCOUNT RECOVERY</span>
                <h1>Reset your<br /><em>password.</em></h1>
                <p>Enter the email linked to your account and we’ll send you a secure reset link.</p>
                {message ? (
                    <div className="auth-success" role="status">
                        <strong>Check your inbox.</strong>
                        <p>{message}</p>
                        <NavLink to="/Login" className="btn btn-smth">Back to sign in</NavLink>
                    </div>
                ) : (
                    <form onSubmit={handleSubmit} className="auth-form">
                        <label>
                            Email address
                            <input type="email" value={email} onChange={(event) => setEmail(event.target.value)} placeholder="you@example.com" autoComplete="email" autoFocus />
                        </label>
                        {error && <p className="account-error" role="alert">{error}</p>}
                        <button type="submit" className="btn btn-smth" disabled={isSubmitting}>
                            {isSubmitting ? 'Sending…' : 'Send reset link'} <span aria-hidden="true">↗</span>
                        </button>
                        <NavLink to="/Login" className="auth-back-link">← Back to sign in</NavLink>
                    </form>
                )}
            </section>
        </main>
    );
}

export default ForgotPassword;